import KatalMetricsPublisher from '@amzn/katal-metrics/lib/KatalMetricsPublisher';
import { useMetrics } from '@amzn/darter-katal-metrics';

export let metricsPublisher: KatalMetricsPublisher;
export let customerIdFromContext = '';

export const makeMetricsPublisher = (customerId: string) => {
  metricsPublisher = useMetrics(customerId, 'BrandRegistryTrim', 'Header');
  customerIdFromContext = customerId;
};

// We publish metrics with Pascal case so this converts a string ID separated with hyphens into using Pascal case
export const formatMetricString = (stringId: string): string => {
  let metricString = '';

  stringId.split('-').forEach((word) => {
    metricString += word.charAt(0).toUpperCase().concat(word.slice(1));
  });

  return metricString;
};
